<template>
  <div style="width: 100%">
    <div style="width: 1340px; margin: 0 auto">
      <h4>
        <el-page-header
          v-if="$route.query.from"
          @back="$router.push($route.query.from)"
          content="个人信息"
        />&nbsp;
      </h4>
      <el-row :gutter="20">
        <!-- 最左列：公司 -->
        <el-col :span="8">
          <el-card style="min-height: 480px">
            <div slot="header">
              <span>任职公司</span>
              <el-button
                type="danger"
                @click="logout"
                size="small"
                style="float: right"
                icon="el-icon-top-left"
              >
                退出系统
              </el-button>
            </div>
            <!-- 有任职公司则显示所在公司列表 -->
            <div v-if="enterprises && enterprises.length > 0">
              <p>在下面选择一家任职公司然后进入系统,或者点击
                <el-link type="primary" @click="dialogVisible = true">
                  这里
                </el-link>登记公司
              </p>
              <el-radio-group v-model="selectedEnterpriseId">
                <el-radio
                  v-for="i in enterprises"
                  :key="i.id"
                  :label="i.id"
                  border
                  style="display: block; margin: 20px 0"
                >
                  {{ i.name }}({{ i.role | roleString }})
                </el-radio>
              </el-radio-group>
              <el-divider></el-divider>
              <el-button
                v-if="enterprises.length > 0"
                type="success"
                @click="enter()"
                size="small"
              >
                进入系统
              </el-button>
            </div>
            <!-- 否则没有任职公司则提示注册 -->
            <div v-else>
              <p v-if="!enterRegister">
                系统中该账号没有任职公司。如果你是公司负责人，可以点击
                <el-link type="primary" @click="enterRegister = true">
                  这里
                </el-link>
                在系统中登记你的公司。或者你需要找到你公司的负责人请他将你加入公司。
              </p>
            </div>

            <el-form
              v-if="enterRegister"
              :rules="entrRegisterRules"
              :model="entrRegisterForm"
              ref="enterpriseForm"
              size="small"
            >
              <el-form-item label="公司名称" prop="name">
                <el-input
                  type="text"
                  v-model="entrRegisterForm.name"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="公司简称" prop="nameAbbr">
                <el-input
                  type="text"
                  v-model="entrRegisterForm.nameAbbr"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="信用号码" prop="credit">
                <el-input
                  type="text"
                  v-model="entrRegisterForm.credit"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="公司地址" prop="address">
                <el-input
                  type="text"
                  v-model="entrRegisterForm.address"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="enterpriseRegisterSubmit">
                  提交公司登记
                </el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-col>
        <!-- 中间列：个人资料 -->
        <el-col :span="8">
          <profile-memo :person-id="personId" />
        </el-col>

        <!-- 最右列：安全和权限 -->
        <el-col :span="8">
          <profile-password :person-id="personId" />
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      >
<!--      -->
      <el-form
        :rules="entrRegisterRules"
        :model="entrRegisterForm"
        ref="enterpriseForm"
        size="small"
      >
        <el-form-item label="公司名称" prop="name">
          <el-input
            type="text"
            v-model="entrRegisterForm.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司简称" prop="nameAbbr">
          <el-input
            type="text"
            v-model="entrRegisterForm.nameAbbr"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="信用号码" prop="credit">
          <el-input
            type="text"
            v-model="entrRegisterForm.credit"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="address">
          <el-input
            type="text"
            v-model="entrRegisterForm.address"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="enterpriseDialgSubmit">
            提交公司登记
          </el-button>
          <el-button @click="cancel">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { enterpriseAdd, listMyEnterprises } from '@/api/enterprise.js'
import localToken from '@/api/local-token.js'
import ProfilePassword from '@/components/_profile/Password.vue'
import ProfileMemo from '@/components/_profile/Memo.vue'
export default {
  name: 'Profile',
  components: { ProfilePassword, ProfileMemo },
  computed: {
    /**
     * 当前企业。如果是刚登录进来，此值为undefined
     */
    currentEnterprise() {
      return this.$store.getters.currentEnterprise
    },
    /**
     * 从哪个uri进入此界面的，用于返回。如果是刚登录进来，此值为undefined
     */
    from() {
      return this.$route.query.from
    },
    /**
     * 当前用户id
     */
    personId() {
      return this.$store.getters.userId
    },
  },
  filters: {
    roleString(val) {
      return val === 'product-manager' ? '管理' : '工人'
    },
  },
  data() {
    return {
      dialogVisible:false,
      enterRegister: false,
      selectedEnterpriseId: undefined,
      enterprises: [],
      entrRegisterRules: {
        name: [
          { required: true, message: '公司名称不能为空', trigger: 'blur' },
        ],
        nameAbbr: [
          { required: true, message: '公司简称不能为空', trigger: 'blur' },
        ],
      },
      entrRegisterForm: {
        name: '',
        nameAbbr:'',
        credit: '',
        address: '',
      },
    }
  },
  mounted() {
    // 加载公司列表，这可能会造成页面直接跳转（刚登录进来且只有一家公司）
    listMyEnterprises(this.personId).then((resp) => {
      this.enterprises = resp.data
    })
    // 如果上下文有当前公司，则把它写到选中的公司字段上，该字段绑定了公司选择列表，在多个公司的情况下，可以显示目前是哪个公司
    if (this.currentEnterprise) {
      this.selectedEnterpriseId = this.currentEnterprise.id
    }
  },
  watch: {
    enterprises: function (enterprises) {
      // 如果只有唯一的任职公司，并且当前公司没有值，说明是刚登录进来的，那么直接跳转进入系统
      if (enterprises && enterprises.length === 1 && !this.currentEnterprise) {
        this.$store.commit('currentEnterprise', enterprises[0])
        this.$router.push('/')
      }
    },
  },
  methods: {
    handleClose(done) {
      console.log('关闭')
      this.$refs.enterpriseForm.resetFields()
      done()
    },
    cancel() {
      this.dialogVisible=false
      this.$refs.enterpriseForm.resetFields()
    },
    enterpriseDialgSubmit() {
      this.$refs.enterpriseForm.validate((valid) => {
        console.log(valid)
        if (valid) {
          this.entrRegisterForm.userId=this.personId
          enterpriseAdd(this.entrRegisterForm).then((data) => {
            this.$message.success(data.message)
            this.dialogVisible=false
            this.enterpriseDate()
          })
        }
      })

    },
    //公司注册提交按钮
    enterpriseRegisterSubmit() {
      this.$refs.enterpriseForm.validate((valid) => {
        console.log(valid)
        if (valid) {
          this.entrRegisterForm.userId=this.personId
          enterpriseAdd(this.entrRegisterForm).then((data) => {
            this.$message.success(data.message)
            this.enterRegister = !this.enterRegister
            this.enterpriseDate()
          })
        }
      })
    },
    enter() {
      const { selectedEnterpriseId, enterprises, from } = this
      if (selectedEnterpriseId === undefined) {
        this.$message.error('请选择公司')
        return
      }
      this.$store.commit(
        'currentEnterprise',
        enterprises.find((item) => {
          return selectedEnterpriseId === item.id
        })
      )
      this.$nextTick(() => {
        this.$router.push(from || '/')
      })
    },
    /**
     * 退出登录
     */
    logout() {
      localToken.clear()
      this.$store.commit('currentEnterprise', undefined)
      this.$store.commit('userId', undefined)
      this.$router.push('/login')
    },
    enterpriseDate() {
      listMyEnterprises(this.personId).then((data) => {
        this.enterprises = data.data
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue